<template>
  <div :id="id" class="snackbar" :class="type">
    <slot name="content"></slot>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "SnackBarNotification",
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  emits: ['switch', 'cancel', 'confirm'],
  computed: {
    ...mapState(["isRTL"]),
  },
  methods: {
    show() {
      var x = document.getElementById("snackbar");
      if (x.style.transform == "scaleY(1)") {
        x.style.transform = "scaleY(0)";
        return
      }
      x.style.transform = "scaleY(1)";
    },
    confirm() {
      this.show()
      this.$emit('confirm')
    },
    close() {
      this.show()
      this.$emit('cancel')
    }
  },
};
</script>

<style scoped>

  .confirm {
    background: #f5f5f5;
  }

  .error {
    background: #f5f5f5;
  }

  .snackbar {
    transform-origin: 0 100%;
    width: 73%;
    height: 66px;
    transform: scaleY(0);
    border-radius: 10px 10px 0px 0px;
    border: 1px solid #e3dbdb !important;
    transition: transform .3s;
    font-size: 15px;
    color: #344767;

    position: absolute;
    top: 88%;
    left: 26%;
  }
  
</style>
